//#region ../erd-editor-schema/dist/v2/schema/canvasEntity.js
var ColumnType = {
	columnUnique: "columnUnique",
	columnAutoIncrement: "columnAutoIncrement",
	columnName: "columnName",
	columnDataType: "columnDataType",
	columnNotNull: "columnNotNull",
	columnDefault: "columnDefault",
	columnComment: "columnComment"
};
var ColumnTypeList = Object.values(ColumnType);
var CanvasType = {
	ERD: "ERD",
	"@vuerd/builtin-sql-ddl": "@vuerd/builtin-sql-ddl",
	"@vuerd/builtin-grid": "@vuerd/builtin-grid",
	"@vuerd/builtin-generator-code": "@vuerd/builtin-generator-code",
	"@vuerd/builtin-visualization": "@vuerd/builtin-visualization"
};
var CanvasTypeList = Object.values(CanvasType);
var Database = {
	MariaDB: "MariaDB",
	MSSQL: "MSSQL",
	MySQL: "MySQL",
	Oracle: "Oracle",
	PostgreSQL: "PostgreSQL",
	SQLite: "SQLite"
};
var DatabaseList = Object.values(Database);
var Language = {
	GraphQL: "GraphQL",
	"C#": "C#",
	Java: "Java",
	Kotlin: "Kotlin",
	TypeScript: "TypeScript",
	JPA: "JPA",
	Scala: "Scala"
};
var LanguageList = Object.values(Language);
var NameCase = {
	none: "none",
	camelCase: "camelCase",
	pascalCase: "pascalCase",
	snakeCase: "snakeCase"
};
var NameCaseList = Object.values(NameCase);
var HighlightTheme = {
	AtomOneDark: "AtomOneDark",
	AtomOneLight: "AtomOneLight",
	MonokaiSublime: "MonokaiSublime",
	GithubGist: "GithubGist",
	VS2015: "VS2015"
};
var HighlightThemeList = Object.values(HighlightTheme);
var BracketType = {
	none: "none",
	doubleQuote: "doubleQuote",
	singleQuote: "singleQuote",
	backtick: "backtick"
};
var BracketTypeList = Object.values(BracketType);
var CANVAS_ZOOM_MIN = .1;
var CANVAS_SIZE_MIN = 2e3;
var CANVAS_SIZE_MAX = 2e4;
//#endregion
export { BracketType, BracketTypeList, CANVAS_SIZE_MAX, CANVAS_SIZE_MIN, CANVAS_ZOOM_MIN, CanvasType, CanvasTypeList, ColumnType, ColumnTypeList, Database, DatabaseList, HighlightTheme, HighlightThemeList, Language, LanguageList, NameCase, NameCaseList };
